import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';

import OptableSummaryDataModel from './OptableSummaryDataModel';

import './OptableMain.css';

export default class OptableMain extends ScheduleMain {
  constructor(props) {
    super(props);

    this.summaryDataModel = new OptableSummaryDataModel(this.counterparty.preferenceGroupName);

    this.isGroupPanelVisible = false;
  }

  componentWillUnmount() {
    this.summaryDataModel.dispose();

    super.componentWillUnmount();
  }

  getDataGridRowClassName() {
    return 'pwx-opt-out-datagrid-row';
  }

  renderUsageSummaries() { }

  async loadGridValues() {
    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.dataModel.revertCurrentModifications();
  }
}
